module.exports = __webpack_public_path__ + "static/media/gf.d0185c11.svg";